import { Button as TaongaButton } from '@portal/taonga-ui'

import { css, cx } from '@news/styled-system/css'

type ViewProps = React.ComponentProps<typeof TaongaButton>

export function Button(props: ViewProps) {
    return (
        <TaongaButton
            {...props}
            // No font class here: taonga-ui's `montserrat` token resolves through --font-montserrat.
            className={cx(props.className, css({ whiteSpace: 'nowrap', fontSize: 'md', lineHeight: 'normal' }))}
        />
    )
}
